(function($) {
    'use strict';

    $(document).ready(function() {
        var win = $(window),
            trigger = $('.js-scroll-top'),
            target = 0,
            set_status = function() {
                var st = win.scrollTop();

                if (st < 500) {
                    trigger.removeClass('shown');
                } else if (!trigger.is('.shown')) {
                    trigger.addClass('shown');
                }
            };

        $(trigger).on('click', function(e) {
            e.preventDefault();

            var cur_offset = win.scrollTop();

            if (cur_offset != target) {
                if (!(cur_offset == 0 && target <= 0)) {
                    // if we are at the top dont try to scroll to top or above
                    $('html:not(:animated),body:not(:animated)').animate({ scrollTop: target }, 1200, 'easeInOutQuint');
                }
            }
        });

        win.on('scroll', function() {
            window.requestAnimationFrame(set_status);
        });
        set_status();
    });
})(jQuery);
